export const SSO = () => ({
  token: '',
  urlReferer: '',
  sandbox: false
})

export const Contexto = () => ({
  slug: '',
  descricao: '',
  imagem: ''
})

export const Operadora = () => ({
  nome: '',
  idCliente: '',
  ans: '',
  clientKey: '',
  unimed: '',
  imagem: ''
})

export const Profile = () => ({
  gestor_atendimento: 0,
  instancia_aplicacao_gestor: {
    sandbox: null,
    producao: null
  },
  instancia_aplicacao: {
    sandbox: null,
    producao: null
  }
})

export const Usuario = () => ({
  id_omni_usuario: null,
  id_omni_cliente_grupo: null,
  status: null,
  nome: '',
  login: '',
  cpf: '',
  email: '',
  telefone: '',
  ramal: '',
  avatar: null,
  profile: Profile,
  data_ultimo_login: '',
  criado_em: '',
  alterado_em: ''
})

export const FormId = () => ({
  formContexto: '',
  formLogin: '',
  formEsqueciSenha: '',
  formRecuperaSenha: ''
})
